import { Component, Input } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.css']
})
export class GraphComponent {
  @Input() chartData!: ChartConfiguration['data'];
  @Input() chartOptions!: ChartOptions;
  @Input() chartType: 'line' | 'bar' | 'pie' | 'doughnut' | 'radar' = 'line';
  @Input() chartLegend = true;
}
